import {McqModel, McqMultiSelectState, McqSingleSelectState, McqState} from './models';

function initialMultiSelectState(model: McqModel): McqMultiSelectState {
  const states: { selected: boolean, checked: boolean }[] = [];
  for (let index = 0; index < model.choices.length; index++)
    states.push({selected: false, checked: false});
  return {states: states};
}

function initialSingleSelectState(model: McqModel): McqSingleSelectState {
  return {selectedIndex: null, checked: false};
}

function initialState(model: McqModel): McqState {
  if (model.behavior === 'multi-select')
    return initialMultiSelectState(model);
  if (model.behavior === 'single-select')
    return initialSingleSelectState(model);
  throw new Error('Unknown behavior ' + model.behavior);
}

class McqUtilsClass {
  readonly initialState = initialState;
}

export const mcqUtils = new McqUtilsClass();
